import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=1e2f4ed0&scoped=true&"
import script from "./user-profile.vue?vue&type=script&lang=js&"
export * from "./user-profile.vue?vue&type=script&lang=js&"
import style0 from "./scss/_index.scss?vue&type=style&index=0&id=1e2f4ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f4ed0",
  null
  
)

export default component.exports